import React, { Suspense, useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar, Footer } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Markets from "@/pages/Markets";
import Services from "@/pages/Services";
import Partners from "@/pages/Partners";
import ForManufacturers from "@/pages/ForManufacturers";
import News, { NewsDetail } from "@/pages/News";
import Contact from "@/pages/Contact";
import { AdminLogin, AdminDashboard } from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center">…</div>}>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/*" element={
              <PublicLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/markets" element={<Markets />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/partners" element={<Partners />} />
                  <Route path="/for-manufacturers" element={<ForManufacturers />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/news/:slug" element={<NewsDetail />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </PublicLayout>
            } />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
